// Street suffixes for self-represented party address
export const STREET_SUFFIXES = [
    { code: 'ALY', name: 'Alley' },
    { code: 'AVE', name: 'Avenue' },
    { code: 'BLVD', name: 'Boulevard' },
    { code: 'CIR', name: 'Circle' },
    { code: 'CT', name: 'Court' },
    { code: 'CV', name: 'Cove' },
    { code: 'DR', name: 'Drive' },
    { code: 'EXPY', name: 'Expressway' },
    { code: 'FWY', name: 'Freeway' },
    { code: 'HL', name: 'Hill' },
    { code: 'HTS', name: 'Heights' },
    { code: 'HWY', name: 'Highway' },
    { code: 'JCT', name: 'Junction' },
    { code: 'LN', name: 'Lane' },
    { code: 'LOOP', name: 'Loop' },
    { code: 'MALL', name: 'Mall' },
    { code: 'PARK', name: 'Park' },
    { code: 'PATH', name: 'Path' },
    { code: 'PKWY', name: 'Parkway' },
    { code: 'PL', name: 'Place' },
    { code: 'PLZ', name: 'Plaza' },
    { code: 'PT', name: 'Point' },
    { code: 'RD', name: 'Road' },
    { code: 'ROW', name: 'Row' },
    { code: 'RUN', name: 'Run' },
    { code: 'SQ', name: 'Square' },
    { code: 'ST', name: 'Street' },
    { code: 'TER', name: 'Terrace' },
    { code: 'TRL', name: 'Trail' },
    { code: 'TRWY', name: 'Throughway' },
    { code: 'VIS', name: 'Vista' },
    { code: 'WALK', name: 'Walk' },
    { code: 'WAY', name: 'Way' },
    { code: 'XING', name: 'Crossing' },
];
